import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { useAuth } from '@/contexts/AuthContext';
import { MyAppearanceCard } from '@/components/settings/MyAppearanceCard';

const ROLE = { business_admin: 'Administrador', cashier: 'Caja', waiter: 'Mozo', kitchen: 'Cocina', super_admin: 'Super Admin' };

export default function ProfilePage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  return (
    <div className="min-h-screen bg-background p-4 md:p-8">
      <div className="max-w-2xl mx-auto space-y-6">
        <Button variant="ghost" onClick={() => navigate(-1)} data-testid="profile-back-btn"><ArrowLeft className="w-4 h-4 mr-2" />Volver</Button>
        <Card>
          <CardContent className="pt-6">
            <h1 className="text-2xl font-bold" data-testid="profile-name">{user?.name}</h1>
            <p className="text-sm text-muted-foreground">{user?.email} · {ROLE[user?.role] || user?.role}</p>
          </CardContent>
        </Card>
        <MyAppearanceCard />
      </div>
    </div>
  );
}
